module.exports = __webpack_public_path__ + "img/thumbnail_Springbok_j_normal.674a8109.png";